import React from 'react';
import type { QueryResult } from 'react-apollo';

import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { DocumentSpaceTitle } from '@confluence/document-title';
import { EditContentButton } from '@confluence/edit-button';
import { fg } from '@confluence/feature-gating';
import type {
	SpaceOverviewQueryType,
	SpaceOverviewQueryVariables,
} from '@confluence/space-overview-query';

import { HubSettingsEntryButton } from '../hub-settings/HubSettingsEntryButton';

const headerContainerStyles = xcss({
	justifyContent: 'space-between',
	padding: 'space.250',
	position: 'absolute',
	right: 'space.0',
	width: '100%',
	alignItems: 'center',
});

const editButtonStyles = xcss({
	background: token('elevation.surface'),
	boxShadow: 'elevation.shadow.raised',
	borderRadius: '100%',
});

const settingsButtonStyles = xcss({
	background: token('elevation.surface'),
	boxShadow: 'elevation.shadow.raised',
	borderRadius: 'border.radius.100',
});

type CompanyHubGroupedButtonsProps = {
	contentId: string;
	spaceKey: string;
	spaceOverviewQueryResult: QueryResult<SpaceOverviewQueryType, SpaceOverviewQueryVariables>;
};

export const CompanyHubGroupedButtons = ({
	contentId,
	spaceKey,
	spaceOverviewQueryResult,
}: CompanyHubGroupedButtonsProps) => {
	if (hasEditPermissions(spaceOverviewQueryResult)) {
		return (
			<Flex xcss={headerContainerStyles}>
				{fg('company_hub_consolidated_settings') ? (
					<Box xcss={settingsButtonStyles}>
						<HubSettingsEntryButton />
					</Box>
				) : (
					<div />
				)}
				<Box xcss={editButtonStyles}>
					<EditContentButton contentId={contentId} isCompanyHubButton />
				</Box>
				<DocumentSpaceTitle spaceKey={spaceKey} />
			</Flex>
		);
	}

	return null;
};

const hasEditPermissions = (
	spaceOverviewQueryResult: CompanyHubGroupedButtonsProps['spaceOverviewQueryResult'],
) =>
	spaceOverviewQueryResult?.data?.space?.homepage?.operations?.some(
		(o) => o?.operation === 'update',
	);
